"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SABRE_UPDATE_IMAGE = void 0;
var client_1 = require("@apollo/client");
var fragments_1 = require("../fragments");
exports.SABRE_UPDATE_IMAGE = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation UpdateImage($input: UpdateImageInput!) {\n    updateImage(input: $input) {\n      image {\n        ...Image\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation UpdateImage($input: UpdateImageInput!) {\n    updateImage(input: $input) {\n      image {\n        ...Image\n      }\n    }\n  }\n  ", "\n"])), fragments_1.IMAGE_FRAGMENT);
var templateObject_1;
